import Handlebars from '@sparta.global.vendors/handlebars';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-mediaquery-utility/dist/es6.js';
import spartaStickyUtility from '@sparta.global.utilities/sparta-sticky-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-store-utility/dist/es6.js';
import '@sparta.global-tenants.utilities/gt-secure-fdic-utility/dist/es6.js';
import { tagline } from '@sparta.global.helpers/tagline-helper/dist/es6.js';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';
import { link } from '@sparta.global.helpers/link-helper/dist/es6.js';

const Template$3 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"logo") : stack1),{"name":"with","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":10},"end":{"line":28,"column":19}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <span itemprop=\"brand\" class=\"ada-hidden\" aria-hidden=\"true\">Bank of America</span>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasLogoLink")),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":12},"end":{"line":12,"column":19}}})) != null ? stack1 : "")
    + "            <img\r\n              itemprop=\"logo\"\r\n              class=\"\r\n                header__logo-image\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"siteHeader"))) && lookupProperty(stack1,"tagline")),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":17,"column":16},"end":{"line":21,"column":23}}})) != null ? stack1 : "")
    + "              \"\r\n              alt=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"alt") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":19},"end":{"line":23,"column":46}}})) != null ? stack1 : "")
    + "\"\r\n              src=\""
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"src") || (depth0 != null ? lookupProperty(depth0,"src") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"src","hash":{},"data":data,"loc":{"start":{"line":24,"column":19},"end":{"line":24,"column":28}}}) : helper))) != null ? stack1 : "")
    + "\"\r\n              role=\"img\"\r\n            />\r\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasLogoLink")),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":12},"end":{"line":27,"column":55}}})) != null ? stack1 : "")
    + "\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <a itemprop=\"url\" href=\""
    + ((stack1 = (lookupProperty(helpers,"renderModuleLink")||(depth0 && lookupProperty(depth0,"renderModuleLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"href") : depth0),{"name":"renderModuleLink","hash":{},"data":data,"loc":{"start":{"line":11,"column":38},"end":{"line":11,"column":65}}})) != null ? stack1 : "")
    + "\">\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "                  header__logo-image--narrow\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"siteHeader"))) && lookupProperty(stack1,"brand")),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":16},"end":{"line":21,"column":16}}})) != null ? stack1 : "");
},"8":function(container,depth0,helpers,partials,data) {
    return "                  header__logo-image--narrow\r\n                ";
},"10":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"alt") || (depth0 != null ? lookupProperty(depth0,"alt") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"alt","hash":{},"data":data,"loc":{"start":{"line":23,"column":30},"end":{"line":23,"column":39}}}) : helper)));
},"12":function(container,depth0,helpers,partials,data) {
    return "</a>";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"header__tagline\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteHeader") : depth0)) != null ? lookupProperty(stack1,"tagline") : stack1)) != null ? lookupProperty(stack1,"text") : stack1),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.program(17, data, 0),"data":data,"loc":{"start":{"line":32,"column":12},"end":{"line":36,"column":19}}})) != null ? stack1 : "")
    + "          </div>\r\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              "
    + container.escapeExpression((lookupProperty(helpers,"tagline")||(depth0 && lookupProperty(depth0,"tagline"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteHeader") : depth0)) != null ? lookupProperty(stack1,"tagline") : stack1)) != null ? lookupProperty(stack1,"text") : stack1),{"name":"tagline","hash":{},"data":data,"loc":{"start":{"line":33,"column":14},"end":{"line":33,"column":49}}}))
    + "\r\n";
},"17":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              "
    + container.escapeExpression((lookupProperty(helpers,"tagline")||(depth0 && lookupProperty(depth0,"tagline"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"array")||(depth0 && lookupProperty(depth0,"array"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"Life","&nbsp;Better&nbsp;Connected",{"name":"array","hash":{},"data":data,"loc":{"start":{"line":35,"column":24},"end":{"line":35,"column":68}}}),{"name":"tagline","hash":{},"data":data,"loc":{"start":{"line":35,"column":14},"end":{"line":35,"column":70}}}))
    + "\r\n";
},"19":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteHeader") : depth0)) != null ? lookupProperty(stack1,"brand") : stack1),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":8},"end":{"line":42,"column":8}}})) != null ? stack1 : "");
},"20":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div data-font=\"cnx-regular\" class=\"header__brand show-for-medium-up\">\r\n            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"siteHeader") : depth0)) != null ? lookupProperty(stack1,"brand") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n          </div>\r\n        ";
},"22":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),blockParams[0][1],"==","searchStub",{"name":"compare","hash":{},"fn":container.program(23, data, 0, blockParams),"inverse":container.program(27, data, 0, blockParams),"data":data,"blockParams":blockParams,"loc":{"start":{"line":52,"column":8},"end":{"line":64,"column":20}}})) != null ? stack1 : "");
},"23":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasSearch")),{"name":"if","hash":{},"fn":container.program(24, data, 0, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":53,"column":10},"end":{"line":61,"column":17}}})) != null ? stack1 : "");
},"24":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"header__child search-stub-child-container\">"
    + ((stack1 = container.lambda(blockParams[2][0], depth0)) != null ? stack1 : "")
    + "</div>\r\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasMenu")),{"name":"unless","hash":{},"fn":container.program(25, data, 0, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":56,"column":12},"end":{"line":60,"column":23}}})) != null ? stack1 : "");
},"25":function(container,depth0,helpers,partials,data) {
    return "              <div class=\"small-search hide\">\r\n                <div class=\"header-search\" data-rwd-content=\"search\" data-rwd-content-rule=\"small\"></div>\r\n              </div>\r\n";
},"27":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1;

  return "          <div class=\"header__child\">"
    + ((stack1 = container.lambda(blockParams[1][0], depth0)) != null ? stack1 : "")
    + "</div>\r\n";
},"29":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"menu-button-wrap\">\r\n          <button\r\n            class=\"spa-btn spa-btn--link menu-button js-menu-button\"\r\n            href=\"javascript:void(0);\"\r\n            aria-expanded=\"false\"\r\n            aria-live=\"polite\"\r\n            aria-label=\"\r\n              "
    + container.escapeExpression((lookupProperty(helpers,"capitalizeFirstLetter")||(depth0 && lookupProperty(depth0,"capitalizeFirstLetter"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"menu") : stack1)) != null ? lookupProperty(stack1,"relatedLinks") : stack1),{"name":"capitalizeFirstLetter","hash":{},"data":data,"loc":{"start":{"line":76,"column":14},"end":{"line":76,"column":70}}}))
    + "\r\n              "
    + ((stack1 = (lookupProperty(helpers,"capitalizeFirstLetter")||(depth0 && lookupProperty(depth0,"capitalizeFirstLetter"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"menu") : stack1)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"capitalizeFirstLetter","hash":{},"data":data,"loc":{"start":{"line":77,"column":14},"end":{"line":77,"column":67}}})) != null ? stack1 : "")
    + "\r\n            \"\r\n          >\r\n            <span class=\"ada-hidden\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"menu") : stack1)) != null ? lookupProperty(stack1,"showHide") : stack1), depth0))
    + "&nbsp;</span>\r\n            <span data-font=\"cnx-medium\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"menu") : stack1)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n            <span class=\"ada-hidden\">&nbsp; "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"menu") : stack1)) != null ? lookupProperty(stack1,"relatedLinks") : stack1), depth0))
    + "</span>\r\n            <span>\r\n              <svg\r\n                class=\"menu-button-arrow\"\r\n                focusable=\"false\"\r\n                version=\"1.1\"\r\n                width=\"20\"\r\n                height=\"10\"\r\n                viewBox=\"0 0 20 12\"\r\n              >\r\n                <path\r\n                  d=\"M 2,2 10,10 18,2\"\r\n                  fill=\"none\"\r\n                  stroke=\"#dc1431\"\r\n                  stroke-width=\"3\"\r\n                  stroke-linejoin=\"miter\"\r\n                  stroke-linecap=\"butt\"\r\n                />\r\n              </svg>\r\n            </span>\r\n          </button>\r\n        </div>\r\n\r\n        <div class=\"arrow__container\">\r\n          <svg\r\n            focusable=\"false\"\r\n            class=\"navigation__arrow\"\r\n            version=\"1.1\"\r\n            width=\"32\"\r\n            height=\"17\"\r\n            viewBox=\"0 0 32 17\"\r\n          >\r\n            <path\r\n              d=\"M 2,2 16,16 30,2\"\r\n              fill=\"#fff\"\r\n              stroke=\"#d1c9c0\"\r\n              stroke-width=\"1\"\r\n              stroke-linejoin=\"miter\"\r\n              stroke-linecap=\"butt\"\r\n            />\r\n          </svg>\r\n        </div>\r\n";
},"31":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"header__secure\">\r\n          "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"secure") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":130,"column":10},"end":{"line":130,"column":46}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n";
},"33":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"menu-nav"),depth0,{"name":"menu-nav","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<header class=\"header header__background header--"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"skin") : stack1), depth0))
    + "\" data-font=\"cnx-regular\">\r\n  <div id=\"gtSecureFdicWidgetContainer\"></div>\r\n  <div class=\"row header__row\">\r\n    <div class=\"header__default\">\r\n      <div itemscope itemtype=\"http://schema.org/Corporation\" class=\"header__logo\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"logo") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":7,"column":8},"end":{"line":29,"column":15}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteHeader") : depth0)) != null ? lookupProperty(stack1,"tagline") : stack1),{"name":"if","hash":{},"fn":container.program(14, data, 0, blockParams),"inverse":container.program(19, data, 0, blockParams),"data":data,"blockParams":blockParams,"loc":{"start":{"line":30,"column":8},"end":{"line":42,"column":15}}})) != null ? stack1 : "")
    + "      </div>\r\n    </div>\r\n\r\n    <div class=\"header__children\">\r\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"top-nav"),depth0,{"name":"top-nav","data":data,"blockParams":blockParams,"indent":"      ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"children") : depth0),{"name":"each","hash":{},"fn":container.program(22, data, 2, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":51,"column":6},"end":{"line":65,"column":15}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"hasMenu") : stack1),{"name":"if","hash":{},"fn":container.program(29, data, 0, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":68,"column":6},"end":{"line":125,"column":13}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"hasSecureLock") : stack1),{"name":"if","hash":{},"fn":container.program(31, data, 0, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":128,"column":6},"end":{"line":132,"column":13}}})) != null ? stack1 : "")
    + "    </div>\r\n  </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"hasMenu") : stack1),{"name":"if","hash":{},"fn":container.program(33, data, 0, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":135,"column":2},"end":{"line":137,"column":9}}})) != null ? stack1 : "")
    + "</header>\r\n\r\n<style type=\"text/css\">\r\n  #globalNavModule .lock-icon::before {\r\n    content: url('"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"secure") : stack1)) != null ? lookupProperty(stack1,"ICON") : stack1), depth0))
    + "');\r\n  }\r\n</style>\r\n";
},"usePartial":true,"useData":true,"useBlockParams":true});
const renderTemplate$3 = function (data, options) {
  return Template$3(data, options);
};

const Template$2 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <li class=\"navigation__item\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"link","hash":{},"data":data,"loc":{"start":{"line":36,"column":35},"end":{"line":36,"column":50}}})) != null ? stack1 : "")
    + "</li>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li class=\"navigation__item js-navigation-item-small\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"link","hash":{},"data":data,"loc":{"start":{"line":50,"column":62},"end":{"line":50,"column":77}}})) != null ? stack1 : "")
    + "</li>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"js-nav-section-container\">\r\n  <span class=\"navigation__title show-for-medium-up\">\r\n    <span data-font=\"cnx-bold\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":3,"column":31},"end":{"line":3,"column":42}}}) : helper))) != null ? stack1 : "")
    + "</span>\r\n  </span>\r\n\r\n  <a\r\n    href=\"javascript:void(0);\"\r\n    class=\"navigation__title navigation__title--small hide-for-medium-up js-nav-section-title\"\r\n    aria-expanded=\"false\"\r\n  >\r\n    <span data-font=\"cnx-bold\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":12,"column":31},"end":{"line":12,"column":42}}}) : helper))) != null ? stack1 : "")
    + "</span>\r\n    <span>\r\n      <svg\r\n        focusable=\"false\"\r\n        class=\"navigation-title-arrow js-navigation-title-arrow hide-for-medium-up\"\r\n        version=\"1.1\"\r\n        width=\"12\"\r\n        height=\"8\"\r\n        viewBox=\"0 0 12 8\"\r\n      >\r\n        <path\r\n          d=\"M 1,1 6,6 11,1\"\r\n          fill=\"none\"\r\n          stroke=\"#666\"\r\n          stroke-width=\"2\"\r\n          stroke-linejoin=\"miter\"\r\n          stroke-linecap=\"butt\"\r\n        />\r\n      </svg>\r\n    </span>\r\n  </a>\r\n\r\n  <ul class=\"navigation__list clearfix show-for-medium-up\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"configureLinks")||(depth0 && lookupProperty(depth0,"configureLinks"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),null,null,(depth0 != null ? lookupProperty(depth0,"order") : depth0),(depth0 != null ? lookupProperty(depth0,"LINKS") : depth0),{"name":"configureLinks","hash":{},"data":data,"loc":{"start":{"line":35,"column":12},"end":{"line":35,"column":50}}}),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":35,"column":4},"end":{"line":37,"column":13}}})) != null ? stack1 : "")
    + "  </ul>\r\n\r\n  <div class=\"hide-for-medium-up\">\r\n    <ul class=\"\r\n      navigation__list\r\n      navigation__list--small\r\n      clearfix\r\n      js-navigation-list-small\r\n      hide\r\n      collapsed\r\n    \">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"configureLinks")||(depth0 && lookupProperty(depth0,"configureLinks"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),null,null,(depth0 != null ? lookupProperty(depth0,"order") : depth0),(depth0 != null ? lookupProperty(depth0,"LINKS") : depth0),{"name":"configureLinks","hash":{},"data":data,"loc":{"start":{"line":49,"column":14},"end":{"line":49,"column":52}}}),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":49,"column":6},"end":{"line":51,"column":15}}})) != null ? stack1 : "")
    + "    </ul>\r\n  </div>\r\n</div>\r\n";
},"useData":true});
const renderTemplate$2 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$2(data, options);
};

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "    <div class=\"search hide-for-medium-up\">\r\n      <div class=\"small-search\">\r\n        <div class=\"header-search\" data-rwd-content=\"search\" data-rwd-content-rule=\"small\"></div>\r\n      </div>\r\n    </div>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          "
    + ((stack1 = (lookupProperty(helpers,"renderTopNavLink")||(depth0 && lookupProperty(depth0,"renderTopNavLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module")),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"language")),{"name":"renderTopNavLink","hash":{},"data":data,"loc":{"start":{"line":21,"column":10},"end":{"line":21,"column":65}}})) != null ? stack1 : "")
    + "\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"navigation__label\" data-font=\"cnx-regular\" for=\"navigation\">\r\n            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"siteHeader") : depth0)) != null ? lookupProperty(stack1,"navLabel") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n          </div>\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"column medium-3 navigation__column\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"sections") : depth0),{"name":"each","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":39,"column":12},"end":{"line":41,"column":21}}})) != null ? stack1 : "")
    + "          </div>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"menu-nav-items"),depth0,{"name":"menu-nav-items","hash":{"LINKS":(depth0 != null ? lookupProperty(depth0,"LINKS") : depth0),"order":(depth0 != null ? lookupProperty(depth0,"sectionOrder") : depth0),"title":(depth0 != null ? lookupProperty(depth0,"sectionTitle") : depth0)},"data":data,"indent":"              ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<nav\r\n  id=\"navigation\"\r\n  class=\"navigation js-nav-container hide\"\r\n  role=\"navigation\"\r\n  data-font=\"cnx-regular\"\r\n  aria-label=\"Top menu navigation links\"\r\n>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"hasSearch") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":2},"end":{"line":14,"column":9}}})) != null ? stack1 : "")
    + "\r\n  <div class=\"row collapse js-sub-nav-container\">\r\n    <div class=\"column navigation__sub-container\">\r\n      <ul class=\"navigation__sub\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"nav") : stack1)) != null ? lookupProperty(stack1,"topNav") : stack1),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":8},"end":{"line":22,"column":17}}})) != null ? stack1 : "")
    + "      </ul>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row small-collapse medium-uncollapse menu-items-container\">\r\n    <div class=\"column\">\r\n      <div class=\"row collapse\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteHeader") : depth0)) != null ? lookupProperty(stack1,"navLabel") : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":8},"end":{"line":35,"column":15}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteHeader") : depth0)) != null ? lookupProperty(stack1,"navColumns") : stack1),{"name":"each","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":8},"end":{"line":43,"column":17}}})) != null ? stack1 : "")
    + "      </div>\r\n    </div>\r\n  </div>\r\n</nav>\r\n\r\n<style type=\"text/css\">\r\n  #globalNavModule .navigation .home-icon::before {\r\n    content: url('"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"home") : stack1)) != null ? lookupProperty(stack1,"ICON") : stack1), depth0))
    + "');\r\n  }\r\n\r\n  #globalNavModule .navigation .locations-icon::before {\r\n    content: url('"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"location") : stack1)) != null ? lookupProperty(stack1,"ICON") : stack1), depth0))
    + "');\r\n  }\r\n\r\n  #globalNavModule .navigation .contact-icon::before {\r\n    content: url('"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"contact") : stack1)) != null ? lookupProperty(stack1,"ICON") : stack1), depth0))
    + "');\r\n  }\r\n\r\n  #globalNavModule .navigation .help-icon::before {\r\n    content: url('"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"help") : stack1)) != null ? lookupProperty(stack1,"ICON") : stack1), depth0))
    + "');\r\n  }\r\n\r\n  #globalNavModule .navigation .espanol-icon::before {\r\n    content: url('"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"spanish") : stack1)) != null ? lookupProperty(stack1,"ICON") : stack1), depth0))
    + "');\r\n  }\r\n\r\n  #globalNavModule .navigation .calendar-icon::before {\r\n    content: url('"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"calendar") : stack1)) != null ? lookupProperty(stack1,"ICON") : stack1), depth0))
    + "');\r\n  }\r\n\r\n  #globalNavModule .navigation .lock-icon::before {\r\n    content: url('"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"secure") : stack1)) != null ? lookupProperty(stack1,"ICON") : stack1), depth0))
    + "');\r\n    background-repeat: no-repeat;\r\n  }\r\n</style>\r\n";
},"usePartial":true,"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <ul class=\"navigation__top\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0),{"name":"with","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":6},"end":{"line":55,"column":15}}})) != null ? stack1 : "")
    + "    </ul>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasSignIn")),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":8},"end":{"line":30,"column":15}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasLocation")),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":8},"end":{"line":37,"column":15}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"language")),"==","es",{"name":"compare","hash":{},"fn":container.program(15, data, 0),"inverse":container.program(19, data, 0),"data":data,"loc":{"start":{"line":38,"column":8},"end":{"line":54,"column":20}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"signInSmallOnly") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":10},"end":{"line":17,"column":17}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"signInMediumUp") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":10},"end":{"line":29,"column":17}}})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li class=\"hide-for-medium-up\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"signInSmallOnly") : depth0),{"name":"with","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":14},"end":{"line":15,"column":23}}})) != null ? stack1 : "")
    + "            </li>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <a\r\n                  class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"actionType") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":25},"end":{"line":10,"column":74}}})) != null ? stack1 : "")
    + "\"\r\n                  id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":11,"column":22},"end":{"line":11,"column":28}}}) : helper)))
    + "\"\r\n                  href=\""
    + ((stack1 = (lookupProperty(helpers,"renderModuleLink")||(depth0 && lookupProperty(depth0,"renderModuleLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"href") : depth0),{"name":"renderModuleLink","hash":{},"data":data,"loc":{"start":{"line":12,"column":24},"end":{"line":12,"column":51}}})) != null ? stack1 : "")
    + "\"\r\n                  "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"actionType") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":18},"end":{"line":13,"column":85}}})) != null ? stack1 : "")
    + "\r\n                >"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":14,"column":17},"end":{"line":14,"column":30}}}) : helper))) != null ? stack1 : "")
    + "</a>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "spa-ui-layer-link spa-fn";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-options=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"actionType") : depth0)) != null ? lookupProperty(stack1,"options") : stack1),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":13,"column":50},"end":{"line":13,"column":77}}}))
    + "\"";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li class=\"show-for-medium-up\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"signInMediumUp") : depth0),{"name":"with","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":14},"end":{"line":27,"column":23}}})) != null ? stack1 : "")
    + "            </li>\r\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <li class=\"show-for-large-up show-for-smallish-only\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"locations") : depth0),{"name":"with","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":33,"column":12},"end":{"line":35,"column":21}}})) != null ? stack1 : "")
    + "          </li>\r\n";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <a id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":34,"column":21},"end":{"line":34,"column":27}}}) : helper)))
    + "\" href=\""
    + ((stack1 = (lookupProperty(helpers,"renderModuleLink")||(depth0 && lookupProperty(depth0,"renderModuleLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"href") : depth0),{"name":"renderModuleLink","hash":{},"data":data,"loc":{"start":{"line":34,"column":35},"end":{"line":34,"column":62}}})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":34,"column":64},"end":{"line":34,"column":77}}}) : helper))) != null ? stack1 : "")
    + "</a>\r\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"isLanguageParam")||(depth0 && lookupProperty(depth0,"isLanguageParam"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"showEnVersion",{"name":"isLanguageParam","hash":{},"data":data,"loc":{"start":{"line":39,"column":16},"end":{"line":39,"column":49}}}),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":39,"column":10},"end":{"line":45,"column":17}}})) != null ? stack1 : "");
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li class=\"show-for-large-up show-for-smallish-only\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showEnglish") : depth0),{"name":"with","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":41,"column":14},"end":{"line":43,"column":23}}})) != null ? stack1 : "")
    + "            </li>\r\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <a id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":42,"column":23},"end":{"line":42,"column":29}}}) : helper)))
    + "\" href=\""
    + ((stack1 = (lookupProperty(helpers,"renderLanguageLink")||(depth0 && lookupProperty(depth0,"renderLanguageLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"href") : depth0),{"name":"renderLanguageLink","hash":{},"data":data,"loc":{"start":{"line":42,"column":37},"end":{"line":42,"column":66}}})) != null ? stack1 : "")
    + "\" hreflang=\"en\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":42,"column":82},"end":{"line":42,"column":95}}}) : helper))) != null ? stack1 : "")
    + "</a>\r\n";
},"19":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"isLanguageParam")||(depth0 && lookupProperty(depth0,"isLanguageParam"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"showEsVersion",{"name":"isLanguageParam","hash":{},"data":data,"loc":{"start":{"line":47,"column":16},"end":{"line":47,"column":49}}}),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":47,"column":10},"end":{"line":53,"column":17}}})) != null ? stack1 : "");
},"20":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li class=\"show-for-large-up show-for-smallish-only\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"enEsp") : depth0),{"name":"with","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":49,"column":14},"end":{"line":51,"column":23}}})) != null ? stack1 : "")
    + "            </li>\r\n";
},"21":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <a id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":50,"column":23},"end":{"line":50,"column":29}}}) : helper)))
    + "\" href=\""
    + ((stack1 = (lookupProperty(helpers,"renderLanguageLink")||(depth0 && lookupProperty(depth0,"renderLanguageLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"href") : depth0),{"name":"renderLanguageLink","hash":{},"data":data,"loc":{"start":{"line":50,"column":37},"end":{"line":50,"column":66}}})) != null ? stack1 : "")
    + "\" hreflang=\"es\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":50,"column":82},"end":{"line":50,"column":95}}}) : helper))) != null ? stack1 : "")
    + "</a>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"top-nav\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"hasTopNav") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":57,"column":9}}})) != null ? stack1 : "")
    + "</div>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

/* eslint-disable func-names */

// Mapping of JCR property key `pointer' to the module param name responsible
// for inclusion/exclusion.
const IS_INCLUDE = {
  location: 'hasLocation',
  home: 'hasNavHome',
  contact: 'hasNavContact',
  help: 'hasNavHelp',
  calendar: 'hasNavCalendar'
};
const IS_INCLUDE_LANGUAGE = {
  spanish: 'showEsVersion',
  english: 'showEnVersion',
  spanishSmall: 'showEsVersion',
  englishSmall: 'showEnVersion'
};
const LANGUAGE_DEFAULTS = {
  esUrl: 'es',
  enUrl: '../',
  showEsVersion: true,
  showEnVersion: true
};

/**
 * Return parameter value in specific order: page if exists, site if exists, default
 * @param {string} paramName - parameter name
 * @param {object} pageParams - page params
 * @param {object} siteParams - site params
 * @return {object} - param
 */
const setParamOrder = (paramName, pageParams, siteParams) => pageParams[paramName] ? pageParams[paramName] : siteParams[paramName] || pageParams[paramName] || LANGUAGE_DEFAULTS[paramName];

/**
 * Error in case anyone upgrades to 10.0.0 and doesn't move params
 * @return {Error} message
 */
const paramError = () => {
  throw new Error(`
    V6 global-nav-module version requires enUrl, esUrl, showEnVersion,
    and showEsVersion parameters to be declared as the site or page level parameters.
    Please move these parameters.
  `);
};
function array(...args) {
  return Array.prototype.slice.call(args, 0, -1);
}
function renderModuleLink(href, options) {
  const moduleParams = options.data.root.module;
  const hrefTemplate = Handlebars.compile(href);
  return hrefTemplate({
    module: moduleParams
  });
}

/**
 * Render language link
 * @param {string} href - link from JCR
 * @param {object} options - sparta options
 * @return {string} language link
 */
function renderLanguageLink(href, options) {
  const siteParams = options.data.root.site;
  const pageParams = options.data.root.page;
  const moduleParams = options.data.root.module;
  if (moduleParams.enUrl || moduleParams.esUrl) paramError();
  moduleParams.enUrl = setParamOrder('enUrl', pageParams, siteParams);
  moduleParams.esUrl = setParamOrder('esUrl', pageParams, siteParams);
  const hrefTemplate = Handlebars.compile(href);
  return hrefTemplate({
    module: moduleParams
  });
}
function configureLinks(globalLinkOrder, globalLinks, siteLinkOrder, siteLinks) {
  // merge site site links over global links
  const links = Handlebars.Utils.extend({}, globalLinks, siteLinks);
  const finalSiteSpecificNavLinks = {};

  // set order of links from site or use global list
  const hasSiteLinkList = Array.isArray(siteLinkOrder);
  const linkOrder = hasSiteLinkList ? siteLinkOrder : globalLinkOrder;
  linkOrder.forEach((link, idx) => {
    finalSiteSpecificNavLinks[idx] = links[link];
  });
  // return new Handlebars.SafeString(r);
  return finalSiteSpecificNavLinks;
}
function renderTopNavLink(linkedItem, moduleConfig, language, options) {
  if (typeof linkedItem === 'undefined') {
    return '';
  }
  const moduleParams = options.data.root.module;
  const siteParams = options.data.root.site;
  const pageParams = options.data.root.page;
  const jcrPointerValue = linkedItem.pointer;
  const isEnglishLink = jcrPointerValue === 'english' || jcrPointerValue === 'englishSmall';
  const isSpanishLink = jcrPointerValue === 'spanish' || jcrPointerValue === 'spanishSmall';
  if (isEnglishLink || isSpanishLink) {
    const paramNameLanguage = IS_INCLUDE_LANGUAGE[jcrPointerValue];
    const siteParamIsIncludeLanguage = siteParams[paramNameLanguage];
    const pageParamIsIncludeLanguage = pageParams[paramNameLanguage];
    const isCurrentLangSpanish = language === 'es';
    let isShowLanguageLink = pageParamIsIncludeLanguage;
    if (siteParamIsIncludeLanguage === undefined && pageParamIsIncludeLanguage === undefined) {
      isShowLanguageLink = LANGUAGE_DEFAULTS[paramNameLanguage];
    }
    if (pageParamIsIncludeLanguage === undefined && siteParamIsIncludeLanguage !== undefined) {
      isShowLanguageLink = siteParamIsIncludeLanguage;
    }

    // don't display language link
    if (!isShowLanguageLink || isEnglishLink && !isCurrentLangSpanish || isSpanishLink && isCurrentLangSpanish) {
      return '';
    }
  }
  if (moduleConfig && jcrPointerValue) {
    const configParamName = IS_INCLUDE[jcrPointerValue];
    // if `has*` module param value is set to false, exclude from displaying
    const isExclude = (configParamName && moduleConfig[configParamName]) === false;

    // don't display link
    if (isExclude) return '';
  }
  moduleParams.enUrl = setParamOrder('enUrl', pageParams, siteParams);
  moduleParams.esUrl = setParamOrder('esUrl', pageParams, siteParams);
  const classes = this.classes || '';
  const link = Handlebars.compile(linkedItem.link)({
    module: moduleParams
  });
  const returnHTML = `<li class="${classes} ${this.hide}">${link}</li>`;
  return new Handlebars.SafeString(returnHTML);
}

/**
 * Get showEnVersion or showEsVersion language parameter value.
 * Parameter assignment order - default, site, page
 * @param {string} param - showEnVersion or showEnVersion
 * @param {object} options - sparta options
 * @returns {boolean|string} param - true to show language link, false to hide
 */
function isLanguageParam(param, options) {
  const moduleParams = options.data.root.module;
  if (moduleParams[param]) paramError();
  const siteParam = options.data.root.site[param];
  const pageParam = options.data.root.page[param];
  if (siteParam === undefined && pageParam === undefined) {
    return LANGUAGE_DEFAULTS[param];
  }
  if (pageParam === undefined && siteParam !== undefined) {
    return siteParam;
  }
  return pageParam;
}

/**
 * Transform string so it looks pretty in JAWS screen reader.
 * @param {string} string - String to cpaitalize.
 * @returns {string} The capitalized value.
 */
function capitalizeFirstLetter(string) {
  return string.replace(/(^\w{1})|(\s{1}\w{1})/g, match => match.toUpperCase());
}

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.global-gt.modules/global-nav-module",
  "version": "1.0.21",
  "id": "globalNavModule",
  "containerID": "globalGtGlobalNavModule",
  "moduleName": "global-gt-global-nav-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "global-nav-module",
  "data": {
    "init": "GlobalNavModuleJS"
  },
  "moduleParams": [{
    "name": "skin",
    "type": "string",
    "values": ["consumer", "smallbusiness", "consumer-legacy"],
    "default": "consumer",
    "description": "Selects a color scheme for the header"
  }, {
    "name": "hasTopNav",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter allows toggling of the navigation links in the top right corner of the header"
  }, {
    "name": "hasNavbar",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter allows toggling of the navigation bar beneath the header."
  }, {
    "name": "hasSearch",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter allows toggling of the search form in the header."
  }, {
    "name": "hasMenu",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "This parameter allows toggling of the menu button with the arrow."
  }, {
    "name": "hasSecureLock",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter allows toggling of the secure lock."
  }, {
    "name": "hasLocation",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "This parameter allows toggling of the locations link."
  }, {
    "name": "hasSignIn",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "This parameter allows toggling of the sign-in link in the sub nav for both lang links."
  }, {
    "name": "hasNavHome",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "This parameter allows toggling of the home link in the sub nav."
  }, {
    "name": "hasNavContact",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "This parameter allows toggling of the contact link in the sub nav."
  }, {
    "name": "hasNavHelp",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "This parameter allows toggling of the help link in the sub nav."
  }, {
    "name": "hasNavCalendar",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "This parameter allows toggling of the calendar link in the sub nav."
  }, {
    "name": "searchText",
    "type": "string",
    "values": ["How can we help you?", "Search"],
    "default": "How can we help you?",
    "description": "The label text that should show up in the header search field."
  }, {
    "name": "homeUrl",
    "type": "string",
    "values": [],
    "default": "/",
    "description": "Set the href for home link in global nav"
  }, {
    "name": "homeUrlEs",
    "type": "string",
    "values": [],
    "default": "/homepage/overview.go?request_locale=es_US",
    "description": "Set the href for Spanish home link in global nav"
  }, {
    "name": "homeUrlEn",
    "type": "string",
    "values": [],
    "default": "/homepage/overview.go?request_locale=en_US",
    "description": "Set the href for English home link in global nav"
  }, {
    "name": "signInUrlSmallOnly",
    "type": "string",
    "values": [],
    "default": "https://staticweb.bankofamerica.com/cavmwebbactouch/common/index.html#home?app=signon",
    "description": "Set the href for sign in link in global nav"
  }, {
    "name": "signInUrlMediumUp",
    "type": "string",
    "values": [],
    "default": "/sitemap/hub/signin.go",
    "description": "Set the href for sign in link in global nav"
  }, {
    "name": "calendarUrl",
    "type": "string",
    "values": [],
    "default": "https://secure.bankofamerica.com/mycommunications/public/appointments/loc.go",
    "description": "Set the href for calendar link in global nav"
  }, {
    "name": "locationUrl",
    "type": "string",
    "values": [],
    "default": "https://locators.bankofamerica.com",
    "description": "Set the href for locations link in global nav"
  }, {
    "name": "locationUrlEs",
    "type": "string",
    "values": [],
    "default": "https://es-locators.bankofamerica.com/locator/locator/LocatorAction.do",
    "description": "Set the href for the Spanish locations link in global nav"
  }, {
    "name": "contactUrl",
    "type": "string",
    "values": [],
    "default": "https://www.bankofamerica.com/contactus/contactus.go",
    "description": "Set the href for contact link in global nav"
  }, {
    "name": "helpUrl",
    "type": "string",
    "values": [],
    "default": "https://www.bankofamerica.com/help/overview.go",
    "description": "Set the href for help link in global nav"
  }, {
    "name": "helpUrlEs",
    "type": "string",
    "values": [],
    "default": "/homepage/overview.go?request_locale=es_US",
    "description": "Set the href for Spanish home link in global nav"
  }, {
    "name": "hasLogoLink",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "Link to homepage from BofA Logo"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$3(context, {
      "helpers": {
        array,
        renderModuleLink,
        renderLanguageLink,
        configureLinks,
        renderTopNavLink,
        isLanguageParam,
        capitalizeFirstLetter,
        tagline,
        compare,
        json,
        link
      },
      "partials": {
        "menu-nav-items": renderTemplate$2,
        "menu-nav": renderTemplate$1,
        "top-nav": renderTemplate
      }
    });
  },
  "template": renderTemplate$3,
  "partials": {
    "menu-nav-items": renderTemplate$2,
    "menu-nav": renderTemplate$1,
    "top-nav": renderTemplate
  },
  "helpers": {
    array,
    renderModuleLink,
    renderLanguageLink,
    configureLinks,
    renderTopNavLink,
    isLanguageParam,
    capitalizeFirstLetter,
    tagline,
    compare,
    json,
    link
  },
  "dependencies": {
    "@sparta.global.helpers/comparisons-helper": "^1.0.3",
    "@sparta.global.helpers/json-helper": "^1.0.2",
    "@sparta.global.helpers/tagline-helper": "^1.0.2",
    "@sparta.global.helpers/link-helper": "^1.0.2",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.3",
    "@sparta.global.utilities/sparta-mediaquery-utility": "^1.0.3",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.7",
    "@sparta.global.utilities/sparta-sticky-utility": "^1.0.5",
    "@sparta.global.utilities/sparta-store-utility": "^1.0.3",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.4",
    "@sparta.global-tenants.utilities/gt-secure-fdic-utility": "^1.0.0",
    "@sparta.global.vendors/handlebars": "^4.7.7"
  },
  "stores": []
};

/* global spartaEventsUtility */

const selectors$1 = {
  navigationContainer: '.js-nav-container',
  subNavigationContainer: '.js-sub-nav-container',
  smallSectionTitle: '.js-nav-section-title',
  smallSectionList: '.js-navigation-list-small',
  smallSectionItems: '.js-navigation-item-small'
};
const cssClasses = {
  open: 'navigation__title--open',
  hide: 'hide',
  hideSmall: 'hide-for-small-up',
  hideMediumUp: 'hide-for-medium-up',
  collapsed: 'collapsed',
  searchLabel: 'spa-circle-btn-label',
  menuArrow: 'menu-button-arrow'
};
const events$1 = {
  menuButtonClicked: 'GLOBAL_NAV_MODULE_MENU_BUTTON.clicked'
};

/**
 * MenuNav
 * @export
 * @class
 */
class MenuNav {
  /**
   * Initalized from global-nav-module.js.
   * @param {object} moduleElement Module element.
   * @returns {void}
   */
  init(moduleElement) {
    const sectionTitle = [...moduleElement.querySelectorAll(selectors$1.smallSectionTitle)];
    sectionTitle.forEach(title => {
      title.addEventListener('click', this.sectionTitleClick.bind(this));
    });

    // Let animations end before acting
    moduleElement.addEventListener('transitionend', MenuNav.hideInvisibleContent, false);
    spartaEventsUtility.sub(events$1.menuButtonClicked, this.toggleNavigation.bind(this, moduleElement));
  }

  /**
   * Toggles the hide class for nav container
   * @param {object} moduleElement Module element.
   * @returns {void}
   */
  toggleNavigation(moduleElement) {
    const navigationContainer = moduleElement.querySelector(selectors$1.navigationContainer);
    // On animation begin, set an explicit height of parent container based on its children.
    requestAnimationFrame(() => {
      navigationContainer.classList.remove(cssClasses.hide);
      requestAnimationFrame(() => {
        // Trigger a transition with the `expanded` class, which will affect stickies.
        navigationContainer.addEventListener('transitionend', function navDoneOnce(e) {
          spartaStickyUtility.recalcStickyEls();

          // Remove this event handler.
          e.target.removeEventListener(e.type, navDoneOnce);
        });
        navigationContainer.classList.toggle('expanded');
      });
    });
  }

  /**
   * Click handler for section title
   * @memberof MenuNav
   * @param {object} event - event object from event listener
   * @returns {void}
   */
  sectionTitleClick(event) {
    const element = event.currentTarget;
    const section = element.parentElement;
    const sectionList = section.querySelector(selectors$1.smallSectionList);
    const sectionListItems = [...sectionList.querySelectorAll(selectors$1.smallSectionItems)];
    element.classList.toggle(cssClasses.open);
    sectionList.classList.remove(cssClasses.hide);
    requestAnimationFrame(() => {
      this.makeAutoHeightExplicitElements({
        targetElement: sectionList,
        referenceElements: sectionListItems
      });
      sectionList.classList.toggle(cssClasses.collapsed);
    });
    MenuNav.setAriaExpanded({
      referenceElem: sectionList,
      targetElem: element,
      invert: false
    });
  }

  /* BEGIN UTIL FUNCTIONS */
  /* eslint-disable class-methods-use-this */
  /**
  * Set the CSS height attribute to a fixed value based on the height of another
  * element on the page. Preferably the child elements of said element.
  * This is helpful for animating (via CSS transform) elements
  * that are laid out with `height: auto`.
  * @param  {object} selectors - CSS selectors to operate
  * @param  {object} targetElements - elements to set height for
  * @param  {array} referenceElements - Selectors for element to read height from
  * @returns {void}
  */
  makeAutoHeightExplicitElements({
    targetElement,
    referenceElements
  }) {
    let contentHeight = 0;
    referenceElements.forEach(element => {
      if (element) {
        contentHeight += element.getBoundingClientRect().height;
      }
    });
    if (targetElement) {
      targetElement.style.height = `${contentHeight}px`;
    }
  }
  /* eslint-enable class-methods-use-this */

  /**
   * Event callback to make hidden content inaccessible to screen readers and keyboard navication
   * @param  {object} event - `transitionend` event called when sections are collapsed/expanded
   * @returns {void}
   */
  static hideInvisibleContent(event) {
    const el = event.target;
    const elIsHidden = !(el.offsetWidth && el.offsetHeight) && !el.classList.contains(cssClasses.searchLabel) && !el.classList.contains(cssClasses.menuArrow);
    if (elIsHidden) {
      el.classList.add(cssClasses.hide);
    }
  }

  /**
  * @param  {object} Elements - Collection of reference and taget `Elements`.
  * Calls `GlobalFooterModuleJS.syncAttrClass` with some properties already set
  *
  * @param  {HTMLElement} Elements.referenceElem - Element to check for 'collapsed' class on
  * @param  {HTMLElement} Elements.targetElem - Element to set the 'aria-expanded' attribute on
  * @returns {void}
  */
  static setAriaExpanded({
    referenceElem,
    targetElem,
    invert
  }) {
    MenuNav.syncAttrClass({
      referenceElem,
      targetElem,
      attr: 'aria-expanded',
      className: cssClasses.collapsed,
      invert
    });
  }

  /**
   * Check if `className` is present on `referenceElem` and set `attr` to `true`
   * if present or `false` if absent
   * @param {object} args - Configuration object
   * @param {HTMLElement} args.referenceElem - Element to check for 'className' class on
   * @param {HTMLElement} args.targetElem - Element to set the attribute on
   * @param {string} args.attr - Attribute to change
   * @param {string} args.className - Name of the class check for
   * @param {boolean} args.invert - `attr` should be false if `className` is present
   *
   * @returns {void}
   */
  static syncAttrClass({
    referenceElem,
    targetElem,
    attr,
    className,
    invert
  }) {
    let attrVal = referenceElem.classList.contains(className);
    if (invert) {
      attrVal = !attrVal;
    }
    targetElem.setAttribute(attr, attrVal);
  }
}
var MenuNav$1 = new MenuNav();

/**
 * @file        global-nav-module.js
 * @description A header for sites that need a header with navigation and search.
 * @copyright   © 2018 Bank of America Corporation. All rights reserved.
 */

const selectors = {
  header: '.header',
  menuButton: '.js-menu-button'
};
const cssModifiers = {
  open: 'header--open'
};
const events = {
  menuButtonClicked: 'GLOBAL_NAV_MODULE_MENU_BUTTON.clicked',
  navigationCollapsed: 'MENU_NAV_MODULE_NAVIGATION.collapsed'
};

/**
 * Default and Parent Class for Global Navigation
 * @export
 * @class GlobalNavModuleJS
 * @extends {Module}
 */
class GlobalNavModuleJS extends Module {
  /**
  * Creates an instance of GlobalNavModuleJS.
  * @param {object} options - used to initialize module.
  * @memberof GlobalNavModuleJS
  */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }
  /**
   * Add event listeners and call initialization functions
   * @returns {void}
   */
  init() {
    const headerModuleElement = this.settings.target;
    const menuButtonElement = headerModuleElement.querySelector(selectors.menuButton);
    if (menuButtonElement) {
      menuButtonElement.addEventListener('click', this.menuButtonClick.bind(this));
      MenuNav$1.init(this.settings.target);
    }
  }

  /**
   * Event Handling for click menu button
   * Fires an event for child module to work from
   * @param {object} event - event passed from listener
   * @returns {void}
   */
  menuButtonClick(event) {
    const header = this.settings.target.querySelector(selectors.header);

    // toggle the 'open' class (this will trigger arrow rotation animation)
    header.classList.toggle(cssModifiers.open);
    this.Events.pub(events.menuButtonClicked);
    GlobalNavModuleJS.setAriaExpanded({
      referenceElem: header,
      targetElem: event.currentTarget,
      invert: false
    });
  }

  /**
   * @param  {object} Elements - Collection of reference and target `Elements`.
   * Calls `GlobalNavModuleJS.syncAttrClass` with some properties already set
   *
   * @param  {HTMLElement} Elements.referenceElem - Element to check for 'collapsed' class on
   * @param  {HTMLElement} Elements.targetElem - Element to set the 'aria-expanded' attribute on
   * @returns {void}
   */
  static setAriaExpanded({
    referenceElem,
    targetElem,
    invert
  }) {
    GlobalNavModuleJS.syncAttrClass({
      referenceElem,
      targetElem,
      attr: 'aria-expanded',
      className: cssModifiers.open,
      invert
    });
  }

  /**
   * Check if `className` is present on `referenceElem` and set `attr` to `true`
   * if present or `false` if absent
   * @param {object} args - Configuration object
   * @param {HTMLElement} args.referenceElem - Element to check for 'className' class on
   * @param {HTMLElement} args.targetElem - Element to set the attribute on
   * @param {string} args.attr - Attribute to change
   * @param {string} args.className - Name of the class check for
   * @param {boolean} args.invert - `attr` should be false if `className` is present
   *
   * @returns {void}
   */
  static syncAttrClass({
    referenceElem,
    targetElem,
    attr,
    className,
    invert
  }) {
    let attrVal = referenceElem.classList.contains(className);
    if (invert) {
      attrVal = !attrVal;
    }
    targetElem.setAttribute(attr, attrVal);
  }
}
registerModuleClass({
  moduleClass: GlobalNavModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { GlobalNavModuleJS as default, moduleConfig };
